import React from "react";
import { CardGridWrapper } from "../../components/Card/CardGridWrapper";
import { CardGridContainer } from "./HomeLayourWrappers";
import NoResults from "./NoResults";
import Card from "../../components/Card/Card";

function ProductGrid({ products, entity, innerWidth }) {
  return (
    <CardGridContainer innerWidth={innerWidth}>
      <CardGridWrapper innerWidth={innerWidth}>
        {products?.length > 0 ? (
          products?.map((product, index) => (
            <Card entity={entity} product={product} reserveBtn key={index} />
          ))
        ) : (
          <NoResults />
        )}
      </CardGridWrapper>
    </CardGridContainer>
  );
}

export default ProductGrid;
